import { Routes } from '@angular/router';
import { permissionGuard } from 'src/lib/guards/permission.guard';
import { LIVE_CHAT_CONFIG } from './base/live-chat-config';

export const liveChatRoutes: Routes = [
  {
    path: LIVE_CHAT_CONFIG.routePath!,
    canActivate: [permissionGuard('QNA$READ')],
    data: { title: 'REPO.TABLE.liveChat._' },
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/live-chat-list-page/live-chat-list-page.component'
          ).then((m) => m.LiveChatListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/live-chat-detail-page/live-chat-detail-page.component'
              ).then((m) => m.LiveChatDetailPageComponent),
          },
        ],
      },
    ],
  },
];
